
function renderBarcodes() {
    var Module = {
        // memoryInitializerPrefixURL:'your-path-here/',
        preRun: [function () {
            Module.FS_createPreloadedFile("/", "Inconsolata.otf",
                                         "fonts/Inconsolata.otf", true, false);
        }],
        postRun: [function () {
            var load_font = Module.cwrap("load_font", 'number',
                                        ['string', 'string', 'number']);
            load_font("Inconsolata.otf", "INCONSOLATA", 108);

            // Load any previously saved fonts
        }]
    };

    $('.barcode').each(function () {
        render(this);
    });
}
function BCFormatMapper(bcCode)
{
    switch (bcCode)
    {
        case '0':
            return 'code11';
            break;
        case '1':
            return 'rationalizedCodabar';
            break;
        case '10':
            return 'ean13';
            break;
        case '11':
            return 'ean8';
            break;
                                case '12':
                                    return 'jan13';
                                    break;
                                case '13':
                                    return 'jan8';
                                    break;
        case '14':
            return 'hibccode39';
            break;
        case '15':
            return 'hibccode128';
            break;
                                case '16':
                                    return 'gs1-128'; 
                                    break;
                                case '17':
                                    return 'interleaved2of5';
                                    break;
        case '18':
            return 'interleaved2of5';
            break;
        case '2':
            return 'msi';
            break;
        case '3':
            return 'code39';
            break;
        case '4':
            return 'code39ext';
            break;
        case '5':
            return 'code93';
            break;
        case '6':
            return 'code128';
            break;
                                    case '7':
                                        return 'gs1-128'; 
                                        break;

        case '8':
            return 'upca';
            break;

        case '9':
            return 'upce';
            break;

        case 'qrcode':
            return 'qrcode';
            break;

        default:
            return '';
    }
}

// ~COACH: 03/02/17  Enhancements made for messaging when bar code format and bar code text are incompatible
function render(canvas) {
    var showText = canvas.getAttribute("bcShowText");
    var cnt = canvas.getAttribute("bcImpression");
    var sym = BCFormatMapper(canvas.getAttribute("bcid"));
    var bcMode = canvas.getAttribute("bcMode");
    var bcScale = canvas.getAttribute("bcScale");
    var bcBearerBars = canvas.getAttribute("bcBearerBars");
    var bcCheckDigits = canvas.getAttribute("bcCheckDigits");

    //bcBearerBars = 'on';
    //bcCheckDigits = 'on';
    
    //alert(bcScale);
    /* custom attributes:
     bcDetailMsg - If Y show a full explanation if barcode is incompatible  
     bcScaleX - a decimal or integer > 0 will be applied
     bcScaleY - a decimal or integer > 0 will be applied
     bcShowText - if Y print text below barcode  (if value = on)
     */


    // determines whether the message is robust or generic
    var custMsgFlag = canvas.getAttribute("bcDetailMsg");
    if (!custMsgFlag) {
        custMsgFlag = 'N';
    }
    else {
        custMsgFlag = 'Y'
    }

    var elt = symdesc[sym];
    var text = canvas.getAttribute("bctxt").replace(/^\s+/, '').replace(/\s+$/, '');
    //var bcheight = (3 * canvas.getAttribute("bc_height")) / 72 
    var altx = '';
    var pmonochrome;
    if (bcMode == 'report')
    {
        var pscaleX = 1;
        var pscaleY = .33;
    }

    if (bcMode == 'preview') {
        //var pscaleX = 1;
        //var pscaleY = 1;
        var pscaleX = bcScale;
        var pscaleY = bcScale;
    }
   
    var cstScaleX = canvas.getAttribute("bcScaleX") 
    var cstScaleY = canvas.getAttribute("bcScaleY") 


    if (cstScaleX) {
        pscaleX = cstScaleX;
    }
    if (cstScaleY) {
        pscaleY = cstScaleY;
    }
    var prot = "";
    var popts;
 
    popts = 'paddingwidth=20 '; //height='+ bcheight;
 
    if (text && bcMode=='preview') {
        popts = 'paddingwidth=20  includetext';
    }

    if (sym == 'qrcode') {

        if (bcMode == 'report') {
            popts = popts + 'eclevel=M version=5';
            pscaleX = 1;
            pscaleY = 1;
        }
        else {
            popts = 'eclevel=M';
            pscaleX = 2;
            pscaleY = 2;
        }
    }
    else {

        if (bcBearerBars == 'yes') {
            popts = popts + ' showborder borderwidth=2 ';
        }

        if (bcCheckDigits == 'yes') {
            popts = popts + ' includecheck ' ;
        }
    }

    //alert(popts);
    var opts = popts
    
    if (!pmonochrome)
    {
        pmonochrome = true;
    }
    var monochrome = pmonochrome;

    // default scaling is 1:3  
    if (!pscaleX)
        {
        pscaleX = 1;
        }
    var scaleX = pscaleX;
    if (!pscaleY)
        {
        pscaleY = 1;
        }
    var scaleY = pscaleY;

    if (!prot)
    {
        prot = 'N';
    }
    var rot = prot;
   
    // Link in the freetype module and how to render fonts.
    var bw = new BWIPJS(Module, monochrome);

    canvas.height = 1;
    canvas.width = 1;
     // Convert the options to a dictionary object, so we can pass alttext with
    // spaces.
    var tmp = opts.split(' ');
    opts = {};
    for (var i = 0; i < tmp.length; i++) {
        if (!tmp[i]) {
            continue;
        }
        var eq = tmp[i].indexOf('=');
        if (eq == -1) {
            opts[tmp[i]] = true;
        } else {
            opts[tmp[i].substr(0, eq)] = tmp[i].substr(eq + 1);
        }
    }

    // Add the alternate text
    if (altx) {
        opts.alttext = altx;
    }
    // BWIPP does not extend the background color into the
    // human readable text.  Fix that in the bitmap interface.
    if (opts.backgroundcolor) {
        bw.bitmap(new Bitmap(opts.backgroundcolor));
        delete opts.backgroundcolor;
    } else {
        bw.bitmap(new Bitmap);
    }

    // Set the scaling factors
    bw.scale(scaleX, scaleY);

    // Add optional padding to the image
    bw.bitmap().pad(+opts.paddingwidth * scaleX || 0,
					+opts.paddingheight * scaleY || 0);
    
    // Render the bar code
    try {
        // Create a new BWIPP instance for each
        BWIPP()(bw, elt.sym, text, opts);
        if ((bcMode == 'report' && showText== 'on') || (showText== 'on'))
        {
            //var nxSb = canvas.nextSibling;
            //alert(nxSb);
            //nxSb.innerHTML = text;
            document.getElementById("dv_" + cnt).style.visibility = 'visible';
            document.getElementById("dv_" + cnt).innerHTML = text;
        }

    } catch (e) {
        // Watch for BWIPP generated raiseerror's.
        var msg = '' + e;
        // ---------------------------------------------------------------------------------------
        // COACH: 03/01/17 Enhancement: return an explantory warning message if barcode cannot be displayed
        var eWarning = '';

        //this is an example of the BWIPP message (colons are theirs) -->  Error: bwipp.upcAbadLength: UPC-A must be 11 or 12 digits
        var Eeq = msg.indexOf(':',6);   // looks like it leads off with Error: <assumption>  
        eWarning = msg.substr(Eeq);  // get the rest of the warning after the 'bwipp...' stuff
  
        // this is original catch{} code which when run will issue a JS alert window
        // --------
        //if (msg.indexOf("bwipp.") >= 0) {
        //    $('#output').text(msg);
        //} else if (e.stack) {
        //    $('#output').text(e.stack);
        //} else {
        //$('#output').text(e);
        // ------

        // find the surrounding <DIV> around the canvas element, because canvas just can't handle innerHTML but its parent can!
        // combination of dvCanvas + the attribute on the canvas element for the bar code text)
        if (custMsgFlag == "Y" || bcMode == 'preview') {
            document.getElementById("dvCanvas" + text).innerHTML = '<p>[ID incompatible with barcode format.]' + eWarning + '</p>';
        }
        else {
            document.getElementById("dvCanvas" + text).innerHTML = '<p>[ID incompatible with barcode format.]</p>';
        }
        // it would be nice if this would work!
        //canvas.innerHTML = '<p>[ID incompatible with barcode format.]' + eWarning + '</p>';
        //}
        return;
    }

    bw.bitmap().show(canvas, rot);
}
